

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import Button from "../../components/button";
// import { fetchInstituteData } from './api';
import CompanyImg from '../../assets/images/khoj-images/image 484.png'

TopInstitute.propTypes = {};

function TopInstitute(props) {
    const token = localStorage.getItem('token')
    const [dataBlock] = useState({
        title: "Top Institute",
        text: "Showing Institute based on reviews and recent job openings",
    });

    const { data } = props;
    const { className } = props;


    const [institutes, setInstitutes] = useState([]);

    const fetchInstituteData = async () => {
        try {
            const response = await axios.post("/Institute/GetAll", {
                pageNumber: 1,
                pageSize: 10,
            });
            console.log("Institute:", response.data.responseData.instituteProfiles);
            setInstitutes(response.data.responseData.instituteProfiles);
        } catch (error) {
            console.error("Error Institute:", error);
        }
    };

    useEffect(() => {
        fetchInstituteData();
    }, []);

    return (
        <section className={className}>
            <div className="container">
                <div className="wd-employer">
                    <div className="tf-title">
                        <div className="group-title">
                            <h1>{dataBlock.title}</h1>
                            <p>{dataBlock.text}</p>
                        </div>
                        <Button title="All Institute" link="/institute" />
                    </div>
                    <div className="row wow fadeInUp">
                        {/* {data.map((idx) => ( */}


                        {institutes.slice(0, 4).map((institute, idx) => (
                            <div key={idx.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="employer-block All-Card-Employer">
                                    <div className="inner-box">
                                        <div className="logo-company">
                                            {/* <img src={institute.logoImage} alt="Jobtex" /> */}
                                            <img src={institute.logoImage} />
                                        </div>
                                        <div className="box-content">
                                            {/* <div className="star">
                                                <span className="icon-star-full"></span>
                                                <span className="icon-star-full"></span>
                                                <span className="icon-star-full"></span>
                                                <span className="icon-star-full"></span>
                                                <span className="icon-star-full"></span>
                                            </div> */}
                                            <h3>
                                                {token === null ? institute.name : <Link to="/employers_v1">{institute.name}</Link>}
                                                &nbsp;
                                                {/* <span className="icon-bolt"></span> */}
                                            </h3>
                                            <p className="info">
                                                {institute.cityName === null ? '' : <>
                                                    <span className="icon-map-pin"></span>{institute.cityName}</>}

                                            </p>
                                        </div>
                                    </div>
                                    {/* <Link
                                        to="/employersingle_v1"
                                        className="jobtex-link-item"
                                        tabIndex="0"
                                    ></Link> */}
                                </div>
                            </div>
                        ))}


                        {/* {Array.isArray(institutes) && institutes.length > 0 ? (
                            institutes.map((institute, idx) => (
                                <div key={institute.id || idx} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="employer-block">
                                        <div className="inner-box">
                                            <div className="logo-company">
                                                <img src={institute.logoImage} alt={institute.name || "Jobtex"} />
                                            </div>
                                            <div className="box-content">
                                                <div className="star">
                                                    <span className="icon-star-full"></span>
                                                    <span className="icon-star-full"></span>
                                                    <span className="icon-star-full"></span>
                                                    <span className="icon-star-full"></span>
                                                    <span className="icon-star-full"></span>
                                                </div>
                                                <h3>
                                                    <Link to="/employers_v1">{institute.title}</Link>
                                                    &nbsp;
                                                    <span className="icon-bolt"></span>
                                                </h3>
                                                <p className="info">
                                                    <span className="icon-map-pin"></span>
                                                    &nbsp;
                                                    {institute.map}
                                                </p>
                                            </div>
                                        </div>
                                        <Link to="/employersingle_v1" className="jobtex-link-item" tabIndex="0"></Link>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No institutes found.</p>
                        )} */}

                    </div>
                </div>
            </div>
        </section>
    );
}

export default TopInstitute;
